<template>
  <div class="container-fluid px-0">
    <div class="row content mx-0">
      <div class="col-1 px-0"></div>
      <div class="col-10 px-0">
        <div class="row mx-0">
          <div class="col-12 px-0 text-end my-3 machStatus-update-time">
            <span class="my-0" id="machStatus-update-time">更新時間:</span>
            <span class="my-0" for="machStatus-update-time">
              {{ nowTime }}
            </span>
          </div>
          <div class="col-12 px-0 text-start">
            <button class="machStatus-button mx-0" @click="detail = false">
              返回
            </button>
          </div>
          <div class="col-12 px-0">
            <div class="row mx-0">
              <div class="col-12 mt-3 px-0 mb-2">
                <div class="row mx-0">
                  <div
                    class="col-12 col-md-12 col-lg-4 col-xl-3 col-xxl-3 px-0"
                  >
                    <img
                      :src="machineImage"
                      class="mx-auto machStatus-main-image"
                      alt="Center image"
                    />
                  </div>
                  <div
                    class="col-12 col-md-12 col-lg-8 col-xl-9 col-xxl-9 px-0"
                  >
                    <div class="row mx-0 text-start machStatus-introduce">
                      <div class="col-12 col-xxl-7 px-0">
                        <div class="row mx-0">
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            製程:{{ siteName }}
                          </div>
                          <div
                            class="col-6 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 px-0 machStatus-introduce-list"
                          >
                            線別:{{ deviceName }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-12 col-xxl-5 px-0 machStatus-status-bar machStatus-introduce-list"
                      >
                        狀態:
                        <div class="machStatus-status-color-bar">
                          <div class="d-flex justify-content-start">
                            <div
                              :style="{
                                'background-color':
                                  machine_status === 'R'
                                    ? 'var(--main-status-success-color)'
                                    : machine_status === 'I'
                                    ? 'var(--main-status-short-color)'
                                    : 'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              {{
                                machine_status === "R"
                                  ? "運轉"
                                  : machine_status === "I"
                                  ? "短寸"
                                  : "運轉"
                              }}
                            </div>
                            <div
                              :style="{
                                'background-color':
                                  machine_status === 'Q'
                                    ? 'var(--main-status-warning-color)'
                                    : machine_status === 'M'
                                    ? 'var(--main-status-maintain-color)'
                                    : machine_status === 'D'
                                    ? 'var(--main-status-shunting-color)'
                                    : 'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              {{
                                machine_status === "Q"
                                  ? "待機"
                                  : machine_status === "M"
                                  ? "維修"
                                  : machine_status === "D"
                                  ? "調車"
                                  : "待機"
                              }}
                            </div>
                            <div
                              :style="{
                                'background-color':
                                  machine_status === 'H'
                                    ? 'var(--main-status-danger-color)'
                                    : 'var(--main-status-stop-color)',
                              }"
                              style="color: var(--main-font-color)"
                            >
                              異常
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mx-0">
                      <div class="col-12 px-0 mb-2">
                        <div class="input-group machStatus-input-group">
                          <span
                            class="input-group-text machStatus-input-group-text"
                            >機台狀態</span
                          >
                          <input
                            type="text"
                            aria-label="First name"
                            class="form-control"
                            disabled
                            :value="'開始時間：' + startTime"
                            style="min-width: 180px"
                          />
                          <input
                            type="text"
                            aria-label="Last name"
                            class="form-control"
                            disabled
                            :value="'預計完工時間：-'"
                            style="min-width: 180px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="px-0">
                    <stackBar
                      :stacksBarClass="stacksBarClass"
                      :stacksBarMaxValue="stacksBarMaxValue"
                      :stacksData="stackBarInformation"
                      :stacksSize="'package-normal'"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12 my-3 px-0">
                <nav class="px-0">
                  <div
                    class="nav nav-tabs mes-tabs"
                    id="nav-tab"
                    role="tablist"
                  >
                    <button
                      class="nav-link mes-tab"
                      :class="{ active: detailTabIndex == 0 }"
                      id="nav-instant-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-instant"
                      type="button"
                      role="tab"
                      aria-controls="nav-instant"
                      aria-selected="true"
                      @click="detailTabIndex = 0"
                    >
                      即時工單狀態
                    </button>
                  </div>
                </nav>
                <div
                  class="tab-content machStatus-tab-content pb-2"
                  id="nav-tabContent"
                >
                  <!-- 即時工單狀態 -->
                  <div
                    class="tab-pane fade"
                    :class="{
                      'show active': detailTabIndex == 0,
                    }"
                    id="nav-instant"
                    role="tabpanel"
                    aria-labelledby="nav-instant-tab"
                  >
                    <div class="row mx-0">
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>工單資訊</span>
                        </div>
                        <commonTable
                          :fields="workCodeFields"
                          :items="workCodeItems"
                        />
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>產品資訊</span>
                        </div>
                        <commonTable
                          :fields="productFields"
                          :items="productItems"
                        />
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>發料資訊</span>
                        </div>
                        <commonTable
                          :fields="shipmentFields"
                          :items="shipmentItems"
                        />
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>包裝資訊</span>
                        </div>
                        <commonTable
                          :fields="packageFields"
                          :items="packageItems"
                        >
                          <template #cell(qty)="data">
                            {{
                              Number(data.value)
                                ? Number(data.value).toLocaleString("en-US")
                                : data.value
                            }}
                          </template>
                          <template #cell(totalWeight)="data">
                            {{
                              Number(data.value)
                                ? Number(data.value).toLocaleString("en-US")
                                : data.value
                            }}
                          </template>
                          <template #cell(piece)="data">
                            {{
                              Number(data.value)
                                ? Number(data.value).toLocaleString("en-US")
                                : data.value
                            }}
                          </template>
                          <template #cell(weight)="data">
                            {{
                              Number(data.value)
                                ? Number(data.value).toLocaleString("en-US")
                                : data.value
                            }}
                          </template>
                          <template #cell(packageQty)="data">
                            {{
                              Number(data.value)
                                ? Number(data.value).toLocaleString("en-US")
                                : data.value
                            }}
                          </template>
                        </commonTable>
                      </div>
                      <div class="col-12 machStatus-paragraph">
                        <div class="machStatus-paragraph-title">
                          <span>棧板資訊</span>
                        </div>
                        <commonTable
                          :fields="palletFields"
                          :items="palletItems"
                        >
                          <template #cell(actQty)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                          <template #cell(consumption)="data">{{
                            isNaN(Number(data.value))
                              ? data.value
                              : Number(data.value).toLocaleString("en-US")
                          }}</template>
                        </commonTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1 px-0"></div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed, inject, provide, ref, watch } from "@vue/runtime-core";
import stackBar from "@/components/stackBar.vue";
import commonTable from "@/components/commonTable.vue";
import machineCamera from "@/components/machineCamera.vue";
import exportCsv from "@/components/exportCsv.vue";
import workOrderHistoryList from "@/components/workOrderHistoryList.vue";
import inspectionList from "@/components/inspectionList.vue";
import light from "@/components/light.vue";
export default {
  components: {
    stackBar,
    commonTable,
    machineCamera,
    exportCsv,
    workOrderHistoryList,
    inspectionList,
    light,
  },
  setup() {
    const siteName = inject("siteName");
    const oper = inject("oper");
    const operName = inject("operName");
    const deviceName = inject("deviceName");
    const detail = inject("detail");
    const machStatusData = inject("machStatusData");
    const nowTime = inject("nowTime");
    const detailTabIndex = inject("detailTabIndex");
    const commonMethods = inject("commonMethods");

    const store = useStore();

    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );
    const stacksBarClass = computed(
      () => store.getters["stackBar/get_stacksBarClass"]
    );
    const stacksBarMaxValue = 43200;
    const stacksBarDefault = computed(
      () => store.getters["stackBar/get_stacksBarDefault"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      triggerLoadingBar: () => {
        store.dispatch("commonLoadingBar/triggerLoadingBar");
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const machineImage = require("@/assets/package-img.png");
    const machine_status = ref("R");
    const startTime = ref("-");
    const stackBarInformation = ref(stacksBarDefault.value);
    console.log(siteName.value, operName.value, deviceName.value, detail.value);

    //工單資訊
    const workCodeFields = [
      {
        key: "lot",
        label: "LOT",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "cusName",
        label: "客戶名稱",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "cusWorkCode",
        label: "客戶單號",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "cusProductCode",
        label: "客戶料號",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "orderCode",
        label: "訂單單號",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "orderItem",
        label: "訂單項次",
        thStyle: {
          "min-width": "75px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const workCodeItems = ref([]);

    //產品資訊
    const productFields = [
      {
        key: "productCode",
        label: "料號",
        thStyle: {
          "min-width": "250px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "specification",
        label: "規格",
        thStyle: {
          "min-width": "150px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "thousand_weight",
        label: "千支重(KG)",
        thStyle: {
          "min-width": "110px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "product_description",
        label: "產品說明",
        thStyle: {
          "min-width": "500px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const productItems = ref([]);

    //發料資訊
    const shipmentFields = [
      {
        key: "containerCode",
        label: "櫃號",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "shipmentCode",
        label: "包裝工令單號",
        thStyle: {
          "min-width": "140px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "packageCode",
        label: "包裝編號",
        thStyle: {
          "min-width": "180px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "packageMethod",
        label: "包裝方式",
        thStyle: {
          "min-width": "90px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "shipmentItem",
        label: "發料批號",
        thStyle: {
          "min-width": "550px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "mark",
        label: "嘜頭",
        thStyle: {
          "min-width": "90px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const shipmentItems = ref([]);

    //生產資訊
    const packageFields = [
      {
        key: "item_title",
        label: ["項目", "狀態"],
        segmentation: {
          sup: {},
          sub: {},
        },
        thStyle: {
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "qty",
        label: "數量(PCS)",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "totalWeight",
        label: "重量(KG)",
        thStyle: {
          "min-width": "95px",
          "font-size": "16px",
          "border-right": "5px solid rgb(102, 102, 102)!important",
        },
        tdStyle: {
          "font-size": "16px",
          "border-right": "5px solid rgb(102, 102, 102)!important",
        },
      },
      {
        key: "item_title_2",
        label: ["項目", "狀態"],
        rowspan: true,
        rowspanKey: "itemTitle2RowspanQty",
        segmentation: {
          sup: {},
          sub: {},
        },
        thStyle: {
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "name",
        label: "名稱",
        rowspan: true,
        rowspanKey: "itemTitle2RowspanQty",
        thStyle: {
          "min-width": "290px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "count",
        label: "支數(PCS)",
        rowspan: true,
        rowspanKey: "itemTitle2RowspanQty",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "piece",
        label: "應包件數",
        rowspan: true,
        rowspanKey: "itemTitle2RowspanQty",
        thStyle: {
          "min-width": "95px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "weight",
        label: "盒重/箱重(KG)",
        rowspan: true,
        rowspanKey: "itemTitle2RowspanQty",
        thStyle: {
          "min-width": "145px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "packageQty",
        label: "即時包裝數量",
        rowspan: true,
        rowspanKey: "realTimeRowspanQty",
        thStyle: {
          "min-width": "140px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "schedule",
        label: "進度",
        rowspan: true,
        rowspanKey: "realTimeRowspanQty",
        thStyle: {
          "min-width": "100px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const packageItems = ref([
      {
        item_title: "規劃",
        qty: "-",
        totalWeight: "-",
        item_title_2: "小盒",
        itemTitle2RowspanQty: 2,
        name: "- ",
        count: "-",
        piece: "-",
        weight: "-",
        packageQty: "-",
        schedule: "-",
        realTimeRowspanQty: 4,
      },
      {
        item_title: "訂單",
        qty: "-",
        totalWeight: "-",
      },
      {
        item_title: "整料包裝前",
        qty: "-",
        totalWeight: "-",
        item_title_2: "外箱",
        itemTitle2RowspanQty: 2,
        name: "- ",
        count: "-",
        piece: "-",
        weight: "-",
      },
      {
        item_title: "實際包裝後",
        qty: "-",
        totalWeight: "-",
      },
      // {
      //   item_title: "規劃",
      //   qty: 184000,
      //   totalWeight: 784,
      //   item_title_2: "小盒",
      //   itemTitle2RowspanQty: 2,
      //   name: "OFCO  D03  125X110X82  小盒 ",
      //   count: "500",
      //   piece: "368",
      //   weight: "2",
      //   packageQty: 182500,
      //   schedule: "99.18%",
      //   realTimeRowspanQty: 4,
      // },
      // {
      //   item_title: "訂單",
      //   qty: 182000,
      //   totalWeight: 777,
      // },
      // {
      //   item_title: "整料包裝前",
      //   qty: 182500,
      //   totalWeight: 784,
      //   item_title_2: "外箱",
      //   itemTitle2RowspanQty: 2,
      //   name: "OFCO  D03  125X110X82  小盒 ",
      //   count: "500(1盒)",
      //   piece: "368",
      //   weight: "2.13",
      // },
      // {
      //   item_title: "實際包裝後",
      //   qty: 182000,
      //   totalWeight: 777,
      // },
    ]);

    //棧板資訊
    const palletFields = [
      {
        key: "palletCode",
        label: "棧板NO",
        thStyle: {
          "min-width": "70px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "palletName",
        label: "棧板名稱",
        thStyle: {
          "min-width": "250px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "box_start",
        label: "箱\n起始",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
          "white-space": "pre-line",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "number_end",
        label: "號\n結束",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
          "white-space": "pre-line",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "mantissa_box_remain",
        label: "尾數箱號\n餘量",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
          "white-space": "pre-line",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "actQty",
        label: "實際回報\n數量",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
          "white-space": "pre-line",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "sglActWeight",
        label: "實際單支重",
        thStyle: {
          "min-width": "90px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "consumption",
        label: "總重量(KG)",
        thStyle: {
          "min-width": "105px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "date",
        label: "回報時間",
        thStyle: {
          "min-width": "130px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
      {
        key: "status",
        label: "狀態",
        thStyle: {
          "min-width": "85px",
          "font-size": "16px",
        },
        tdStyle: {
          "font-size": "16px",
        },
      },
    ];
    const palletItems = ref([]);

    const updateData = () => {
      if (machStatusData.value != null) {
        machine_status.value = machStatusData.value.machine_status;
        startTime.value = machStatusData.value.startTime;
        stackBarInformation.value = machStatusData.value.stack_bar_information;

        workCodeItems.value = machStatusData.value.work_code_information;
        productItems.value = machStatusData.value.product_information;
        shipmentItems.value = machStatusData.value.shipment_information;
        packageItems.value = machStatusData.value.package_information;
        palletItems.value = machStatusData.value.pallet_information;
      }
    };

    watch(
      machStatusData,
      () => {
        updateData();
      },
      { deep: true }
    );

    return {
      siteName,
      operName,
      deviceName,
      detail,
      machineImage,
      nowTime,
      startTime,
      machine_status,
      stacksBarClass,
      stacksBarMaxValue,
      stackBarInformation,
      detailTabIndex,
      workCodeFields,
      workCodeItems,
      productFields,
      productItems,
      shipmentFields,
      shipmentItems,
      packageFields,
      packageItems,
      palletFields,
      palletItems,
    };
  },
};
</script>

<style></style>
